import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

http.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("ipg_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail.msg || String(detail);
}

export const mapEmbed = (loc) =>
  `https://maps.google.com/maps?q=${encodeURIComponent(fullAddress(loc))}&z=15&output=embed`;

export const directionsUrl = (loc) =>
  `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(fullAddress(loc))}`;

export const fullAddress = (loc) => `${loc.address}, ${loc.city}, ${loc.state} ${loc.zip}`;

export const money = (n) => `$${Number(n).toLocaleString("en-US")}`;
